export const getImage = (name: string) => {
  return { __html: require(`!raw-loader!../img/${name}.svg`) };
};
